import { Injectable } from '@angular/core';
import { ICities } from 'src/app/@interfaces/cities.interface';

@Injectable({
  providedIn: 'root',
})
export class CitiesFilterService {
  constructor() {}

  filterCities(value: string, cityList: string[]): string[] {
    const filterValue = value?.toString().toLowerCase();
    return cityList
      ? cityList
          .filter((option) =>
            option.toLowerCase().toString().includes(filterValue),
          )
          .slice(0, 10)
      : [];
  }

  filterCitiesList(value: string, cityList: ICities[]): ICities[] {
    const filterValue = value?.toLowerCase() ?? '';
    return cityList
      ? cityList
          .filter((city) => city.name?.toLowerCase().includes(filterValue))
          .slice(0, 10)
      : [];
  }
}
